<template>
  <!-- 产品结算政策 -->
  <div class="main-container">
    <Tabs v-model="settleRuleType" :animated="false" @on-click="tabClick()" v-if="$units.pointAction('pro_9_1') && $units.pointAction('pro_9_2')">
      <TabPane label="上游结算规则" name="1"></TabPane>
      <TabPane label="机构结算规则" name="2"></TabPane>
    </Tabs>
    <div class="search-box btn3" :class="{ close: !searchMore }">
      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyCode" transfer clearable filterable>
          <Option v-for="(bean, i) in companyList" :key="i" :value="bean.code">{{ bean.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input v-model="searchParams.productName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">产品编码</span>
        <Input v-model="searchParams.productCode" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">业务类别</span>
        <RadioGroup v-model="searchParams.sellType" @on-change="searchAjax()">
          <Radio label="">全部</Radio>
          <Radio label="1">网销</Radio>
          <Radio label="3">经代</Radio>
        </RadioGroup>
      </div>
      <!-- <div class="input-item">
        <span class="label">险种分类</span>
        <Select v-model="searchParams.themeIds" placeholder="请选择" clearable multiple>
          <Option v-for="item in productThemeList" :key="item.id" :value="item.id" :label="item.name"> </Option>
        </Select>
      </div> -->
      <div class="input-item">
        <span class="label">长短险标志</span>
        <RadioGroup v-model="searchParams.productType" @on-change="searchAjax()">
          <Radio label="">全部</Radio>
          <Radio label="1">长险</Radio>
          <Radio label="2">短险</Radio>
        </RadioGroup>
      </div>
      <div class="input-item" v-if="$units.superviseShowVal() && $units.pointAction('pro_9_3')">
        <span class="label">供应商类型</span>
        <RadioGroup v-model="searchParams.supplierType" @on-change="changeSupplierType">
          <Radio label="">全部</Radio>
          <Radio label="1">保司</Radio>
          <Radio label="2">通道</Radio>
        </RadioGroup>
      </div>
      <div class="input-item" v-if="searchParams.supplierType && $units.superviseShowVal() && $units.pointAction('pro_9_3')">
        <span class="label">供应商</span>
        <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable>
          <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <!-- <div class="input-item" v-if="settleRuleType == '1'">
        <span class="label">上架状态</span>
        <RadioGroup v-model="searchParams.publishStatus" @on-change="searchAjax()">
          <Radio label="">全部</Radio>
          <Radio label="2">已上架</Radio>
          <Radio label="1">已下架</Radio>
        </RadioGroup>
      </div> -->
      <div class="input-item" v-if="settleRuleType == '1'">
        <span class="label">是否可售产品</span>
        <RadioGroup v-model="searchParams.salesStatus" @on-change="searchAjax()">
          <Radio label="">全部</Radio>
          <Radio label="2">是</Radio>
          <Radio label="1">否</Radio>
        </RadioGroup>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
        <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
          >收起
          <Icon type="ios-arrow-up" />
        </Button>
        <Button type="primary" ghost v-else @click="searchMore = true"
          >展开
          <Icon type="ios-arrow-down" />
        </Button>
      </div>
    </div>
    <div class="tools-box right">
      <Button type="primary" @click="daochu()" ghost>导出</Button>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <div class="tableBox">
        <Table :columns="columns" :data="tableData" row-key="id">
          <template slot-scope="{ row }" slot="productName">
            <div class="product-name">
              <div class="sellTypeColumn" v-if="row.sellType">
                <Tag color="blue" v-if="row.sellType.includes('1')">网销</Tag>
                <Tag color="blue" v-if="row.sellType.includes('2')">电销</Tag>
                <Tag color="blue" v-if="row.sellType.includes('3')">经代</Tag>
              </div>
              <div class="name-box">
                <span class="pro-text">
                  <span>{{ row.productName }}</span>
                  <span v-if="row.productCode">({{ row.productCode }})</span>
                </span>
                <div class="tag" v-if="row.salesStatus == 1">不可售</div>
              </div>
            </div>
          </template>
          <!-- 首期结算规则 -->
          <template slot-scope="{ row }" slot="settleRule1">
            <div class="html-content" v-for="(text, i) in row.settleRule1" :key="i" v-html="text"></div>
          </template>
          <!-- 续期结算规则 -->
          <template slot-scope="{ row }" slot="settleRule2">
            <div class="html-content" v-for="(text, i) in row.settleRule2" :key="i" v-html="text"></div>
          </template>
          <!-- 其他规则 -->
          <template slot-scope="{ row }" slot="settleRule3">
            <div class="html-content" v-for="(text, i) in row.settleRule3" :key="i" v-html="text"></div>
          </template>
          <template slot-scope="{ row }" slot="fee">
            <div style="margin-right: 0">
              <template v-if="row.min != row.max">
                <span>{{ row.min }}%</span>-<span>{{ row.max }}%</span>
              </template>
              <span v-else>{{ row.min }}%</span>
            </div>
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from './index.config.js';
import { mapState } from 'vuex';
import { pageTool, common } from '@/api/mixins';
import selectRegion from '@/components/commons/selectRegion';
export default {
  name: 'productPolicy.index',
  components: {
    selectRegion
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mixins: [pageTool, common, config],
  data() {
    return {
      searchMore: true,
      productThemeList: [],
      supplierList: [],
      companyList: [],
      settleRuleType: '1',// 1-上游结算规则 2-机构结算规则
      //表单搜索字段
      searchParams1: {
        themeIds: [],
        salesStatus: '2'
      },
      searchParams2: {},
      searchParams: {},
      tableData: [],
      columns: []
    };
  },
  mounted() {
    if(this.$units.pointAction('pro_9_1')) {
      this.settleRuleType = '1';
    }else if(this.$units.pointAction('pro_9_2')) {
      this.settleRuleType = '2';
    }
    this.tabClick();
    this.getProductTheme();
    this.geCompanyList();
    this.getColumns();
    this.initListParams('/buz/productBase/settleRule/list');
  },
  activated() {
    if (!this.$units.superviseShowVal()) {
      this.searchParams.supplierType = '1';
    }
    this.getList();
  },
  methods: {
    // 导出
    daochu() {
      if(this.settleRuleType == 1 && !this.$units.pointAction('pro_9_5')) {
        this.$Message.error('无权操作，请联系您的上级')
        return;
      }
      if(this.settleRuleType == 2 && !this.$units.pointAction('pro_9_6')) {
        this.$Message.error('无权操作，请联系您的上级')
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/productBase/settleRule/export', params, 'POST', this.settleRuleType == 1 ? '上游产品结算政策' : '机构产品结算政策');
    },
    // 切换tab
    tabClick() {
      this.tableData = [];
      if(this.settleRuleType == 1) {
        this.searchParams2 = JSON.parse(JSON.stringify(this.searchParams));
        this.searchParams = JSON.parse(JSON.stringify(this.searchParams1));
      }
      if(this.settleRuleType == 2) {
        this.searchParams1 = JSON.parse(JSON.stringify(this.searchParams));
        this.searchParams = JSON.parse(JSON.stringify(this.searchParams2));
      }
      this.searchAjax();
    },
    //险种分类
    getProductTheme() {
      this.$http({
        url: '/buz/productTheme/array/first',
        type: 'GET',
        data: {}
      }).then(res => {
        //赠险公司列表初始化
        this.productThemeList = res.data;
      });
    },
    showDemand(row) {
      this.$refs.demandModal.open(row);
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all';
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list';
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then(res => {
          this.supplierList = res.data;
        });
      }
    },
    //列表保险公司
    geCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        //赠险公司列表初始化
        this.companyList = res.data;
      });
    },
    setReqParams(params) {
      params.apiPermissionCode = 'pro_2_0';
    },
    setListParams(params) {
      if (params.insureType && params.insureType.length > 0) {
        params.insureType = params.insureType.length > 1 ? params.insureType.join('|') : params.insureType.length == 1 ? params.insureType.join(',') : '';
      } else {
        delete params.insureType;
      }
      params.settleRuleType = this.settleRuleType
      if(params.settleRuleType == '2') {
        delete params.publishStatus;
        delete params.salesStatus;
      }
    },
    deleteProduct(idList, flag) {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.listLoading = true;
      this.$http({
        url: '/buz/productBase/batchUpdatePublishStatus',
        type: 'post',
        data: {
          updatePublishStatus: flag ? 2 : 1,
          idList,
          ...params
        }
      })
        .then(res => {
          this.isAll = false; //全选
          this.getList();
          this.$notice.success(`产品批量${flag ? '上架' : '下架'}成功`);
          // this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    listCallback(res) {
      res.data.forEach(item=>{
        if(item.settleRule) {
          const list = JSON.parse(item.settleRule);
          const settleRule1 = [];
          const settleRule2 = [];
          const settleRule3 = [];
          list.forEach(item2 => {
            if(item2.name == '首期结算规则') {
              settleRule1.push(item2.content);
            }
            if(item2.name == '续期结算规则') {
              settleRule2.push(item2.content);
            }
            if(item2.name == '其他规则') {
              settleRule3.push(item2.content);
            }
          })
          item.settleRule1 = settleRule1;
          item.settleRule2 = settleRule2;
          item.settleRule3 = settleRule3;
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
